import { render, staticRenderFns } from "./UsernameLink.vue?vue&type=template&id=2494fd61&scoped=true&"
import script from "./UsernameLink.vue?vue&type=script&lang=js&"
export * from "./UsernameLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494fd61",
  null
  
)

export default component.exports